module.exports = __webpack_public_path__ + "static/media/vibinoLogoC.055ce7e6.svg";